module.exports = __webpack_public_path__ + "img/3.07fbc326.png";